import { DescriptionText, SectionContent } from "components/suggestion-context/styled";
import intl from "react-intl-universal";

interface WithTitleLineProps {
  quantityCalculation?: string;
}

const WithTitleLine = (props: WithTitleLineProps) => {
  const { quantityCalculation } = props;

  if (!quantityCalculation) return null;

  return (
    <SectionContent>
      <DescriptionText $fontWeight={700} $fontSize="0.75rem">
        {intl.get("stocks.suggestionContext.withTitleLine.title")}
      </DescriptionText>
      <DescriptionText>{quantityCalculation}</DescriptionText>
    </SectionContent>
  );
};

export default WithTitleLine;
